import React, {useEffect, useState} from 'react'
import ButtonContainer from '../Components/ButtonContainer';
import COLORS from '../Colors';
import '../Styles/StartEndScreen.css';
import { withRouter } from "react-router-dom";
import { CognitoHelper } from '../Utilities/CognitoHelper';
import { PATH_NAMES } from '../Utilities/Constants';
import * as api from '../Scripts/Api';

function Welcome(props) {
  useEffect(() => {
    document.body.style.height = '100%';
  }, []);

  const [counter, setCounter] = useState(0);

  sessionStorage.setItem('questionnaireIdx', 0);
  sessionStorage.setItem('testIdx', 0);
  sessionStorage.setItem('answers', JSON.stringify({}));

  var text = [
    <div>
      <h1 className='card-title'>👋 Hello!</h1>
      <p className='card-text'>You will do a couple of short activities to help us gain a better understanding of your brain health.</p>
    </div>,
    <div>
      <h1 className='card-title'>👋 ¡Hola!</h1>
      <p className='card-text'>Realizará un par de actividades cortas para ayudarnos a comprender mejor la salud de su cerebro</p>
    </div>,]

  var confirmation = [
    'Tap here to get started',
    'Toque aquí para comenzars'
  ]

  function clickNext() {
    //logout backdoor
    signOutBackdoor()
    console.log("counter is: " + counter);
    //let currentTime = new Date().getTime()
    //sessionStorage.setItem('startTime', currentTime);
    setCounter(1)
    const prefLang = sessionStorage.getItem("preferredLanguage");
    const langIndex = prefLang === "ES" ? 1 : 0;
    const queryParams = {
      prefLang: prefLang,
      langIndex: langIndex
    };
    // Construct the query string
    const queryString = new URLSearchParams(queryParams).toString();

    // props.history.push({
    //   pathname: `/PATH_NAMES.QUESTIONNAIRE?${queryString}`
    // })
    props.history.push({
      pathname: PATH_NAMES.QUESTIONNAIRE
    })
  }

  //TODO: remove when signout is no longer needed
  const signOutBackdoor = () => {
    if (sessionStorage.getItem('logout') === '1'){
      signOut();
    }
  }

  const signOut = () => {
    const cognitoHelper = new CognitoHelper()

    cognitoHelper.signOut(function() {
      console.log("signed out")
    })
  }

  const langIndex = sessionStorage.getItem("preferredLanguage") === "ES" ? 1 : 0;

  return (
    <>
        <div className='card'>
          {text[langIndex]}
          <ButtonContainer
            colors={[COLORS.green]}
            buttonTexts={[confirmation[langIndex]]}
            buttonType='filled'
            onClick={() => clickNext()}
          />
        </div>
      </>
  );
}

export default withRouter(Welcome);